module.exports = __webpack_public_path__ + "img/mobile-ribbon-left.2a08f1db.webp";